import { render } from "./small.vue?vue&type=template&id=75de9cc8&scoped=true&ts=true"
import script from "./small.vue?vue&type=script&lang=ts"
export * from "./small.vue?vue&type=script&lang=ts"

import "./small.vue?vue&type=style&index=0&id=75de9cc8&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75de9cc8"]])

export default __exports__